export class PartitionModel {
  constructor(
    public target = '',
    public source = '',
    public func = 'SUM',
    public constant: number | null = null,
    public over: OverModel = new OverModel(),
    public null_operator: string | null = null,
  ) {}
}

export class OverModel {
  constructor(
    public partition: string[] = [],
    public order: FieldModel[] = [],
    public row_range: RowRangeModel = new RowRangeModel(),
  ) {}
}

export class RowRangeModel {
  constructor(
    public is_between = true,
    public from: RowRangeFieldModel = new RowRangeFieldModel(),
    public to: RowRangeFieldModel = new RowRangeFieldModel(),
  ) {}
}

export class FieldModel {
  constructor(public field = '', public direction = 'ASC') {}
}

export class RowRangeFieldModel {
  constructor(public range = '', public action = '') {}
}
